if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        // First try to find the exact media item
        let activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        
        // If not found, try to find a valid fallback with an actual image
        if (!activeMedia) {
          const allMediaItems = this.elements.viewer.querySelectorAll('[data-media-id]');
          for (const item of allMediaItems) {
            const img = item.querySelector('img');
            if (img && img.src && !img.src.includes('placeholder')) {
              activeMedia = item;
              break;
            }
          }
          // Last resort: use first available media item
          if (!activeMedia && allMediaItems.length > 0) {
            activeMedia = allMediaItems[0];
          }
        }
        
        if (!activeMedia) {
          console.warn('No active media found for:', mediaId);
          return;
        }
        
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (activeThumbnail) {
              activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }
        
        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        if (activeThumbnail && activeThumbnail.dataset.mediaPosition) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }
      // setActiveMedia(41678523105599, 'false);

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

// // Get the media gallery element
// const mediaGallery = document.querySelector('media-gallery');

// // Get the second media element's ID from the thumbnails
// const thumbnails = mediaGallery.querySelector('[id^="GalleryThumbnails"]');
// const secondThumbnail = thumbnails.querySelectorAll('[data-target]')[1]; // Index 1 for second element
// const secondMediaId = secondThumbnail.dataset.target;

// // Trigger setActiveMedia with the second media ID and prepend = true
// mediaGallery.setActiveMedia(secondMediaId, true);

document.addEventListener("DOMContentLoaded", () => {
  // Immediately activate on page load - no waiting
  const mediaGallery = document.querySelector('media-gallery');
  if (!mediaGallery) return;

  const selectedSpan = document.querySelector('span[data-selected-value]');
  if (!selectedSpan) return;

  const selectedText = selectedSpan.textContent.trim();
  if (!selectedText) return;

  // Find matching media item instantly
  const allMediaItems = mediaGallery.querySelectorAll('li[data-media-id]');
  for (const item of allMediaItems) {
    const img = item.querySelector('img');
    if (img && img.alt && img.alt.toLowerCase().includes(selectedText.toLowerCase())) {
      const targetMediaId = item.getAttribute('data-media-id');
      if (targetMediaId) {
        mediaGallery.setActiveMedia(targetMediaId, false);
      }
      break;
    }
  }
});

// Cache for faster lookups
const mediaCache = new Map();

// Build cache on load
function buildMediaCache() {
  const mediaGallery = document.querySelector('media-gallery');
  if (!mediaGallery) return;
  
  mediaCache.clear();
  const allMediaItems = mediaGallery.querySelectorAll('li[data-media-id]');
  
  allMediaItems.forEach(item => {
    const img = item.querySelector('img');
    if (img && img.alt) {
      const altKey = img.alt.toLowerCase().trim();
      if (!mediaCache.has(altKey)) {
        mediaCache.set(altKey, item.getAttribute('data-media-id'));
      }
      // Also cache partial matches
      altKey.split(/[\s-]+/).forEach(word => {
        if (word.length > 2 && !mediaCache.has(word)) {
          mediaCache.set(word, item.getAttribute('data-media-id'));
        }
      });
    }
  });
}

// Run cache build after DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', buildMediaCache);
} else {
  buildMediaCache();
}

// Fast variant switcher
var ww = document.querySelector('span[data-selected-value]');
if (ww) {
  let lastValue = ww.textContent.trim();
  
  new MutationObserver(() => {
    const newValue = ww.textContent.trim();
    if (!newValue || newValue === lastValue) return;
    lastValue = newValue;
    
    const mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery) return;
    
    // Use opacity instead of visibility for faster paint
    mediaGallery.style.opacity = '0.3';
    mediaGallery.style.transition = 'opacity 0.15s ease';
    
    // Try cache first for instant lookup
    const cacheKey = newValue.toLowerCase().trim();
    let targetMediaId = mediaCache.get(cacheKey);
    
    // If not in cache, do quick search
    if (!targetMediaId) {
      const allMediaItems = mediaGallery.querySelectorAll('li[data-media-id]');
      for (const item of allMediaItems) {
        const img = item.querySelector('img');
        if (img && img.alt && img.alt.toLowerCase().includes(cacheKey)) {
          targetMediaId = item.getAttribute('data-media-id');
          // Add to cache for next time
          mediaCache.set(cacheKey, targetMediaId);
          break;
        }
      }
      // Fallback to first item
      if (!targetMediaId && allMediaItems.length > 0) {
        targetMediaId = allMediaItems[0].getAttribute('data-media-id');
      }
    }
    
    if (targetMediaId) {
      mediaGallery.setActiveMedia(targetMediaId, false);
    }
    
    // Show immediately - no delay
    requestAnimationFrame(() => {
      mediaGallery.style.opacity = '1';
    });
    
  }).observe(ww, { childList: true, characterData: true, subtree: true });
}